import React from 'react';

import FooterOne from '../layout/Footer/FooterOne';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import PageMeta from '../components/common/PageMeta';
import HeroEightCustom from './HeroEightCustom';

import TrialBanner from "../components/trial/trialbanner";


const BlogDetails = () => {
    const inlineCodeStyle = {
        backgroundColor: '#f5f5f5',
        fontFamily: 'monospace',
        fontSize: '0.95em',
        padding: '2px 4px',
        borderRadius: '4px',
        color: '#c7254e',
        border: '1px solid #e1e1e8',
      };
    return (
        <>
            <Layout>
                <PageMeta title='SFTP MCP Server Setup' description="Complete SFTP MCP Setup guide, integrate an SFTP connection in Claude desktop." />
                <Navbar navDark />
                <HeroEightCustom>
                    Introducing: Our new shared mailbox feature
                </HeroEightCustom>

                <section className='blog-details ptb-120'>
                    <div className='container'>
                        <div className='row justify-content-between'>
                            <div className='col-lg-9 pe-5'>
                                <div className='blog-details-wrap'>
          
                                    <p>
                                      We're excited to announce the launch of Shared Mailboxes — a powerful new feature designed to streamline your document workflows and make team collaboration even more seamless.
                                    </p>
                       


                                    <h3 className="mt-40">What Are Shared Mailboxes?</h3>
                                    <p>
                                        Shared Mailboxes allow you and your team to configure dedicated email addresses that can receive documents from anyone inside or outside your organization. These mailboxes act as centralized inboxes where documents can be automatically routed and transferred to the data source of your choice.
                                    </p>

        
                                    <h3 className="mt-40">How do I setup a shared mailbox?</h3>
                                    <p>
                                        <b>Prerequisites: </b>
                                        <ul>
                                            <li>A FilePulse account (Register for free <a href="https://app.filepulse.io/auth/register">here</a>)</li>
                                            <li>At least one valid datasource</li>
                                        </ul>
                                    </p>
                                    <p>
                                        <b>1. Navigate to the mailboxes menu</b>

                                        After navigating to the mailboxes overview, click on; "Add mailbox" in the top right corner
                                    </p> 

                                     <div className='row mb-120'>
                                    <div className='col-lg-6 col-12 order-lg-0'>
                                                <img
                                                    src='/assets/blog/mailboxes/mailboxes_1.png'
                                                    className='img-fluid'
                                                    alt='feature-img'
                                                />
                                    
                                
                                        </div>
                                    <div className='col-lg-6 col-12 order-lg-0'>
                                          
                              
                                            <img
                                                src='/assets/blog/mailboxes/mailboxes_2.png'
                                                className='img-fluid'
                                                alt='feature-img'
                                            />
                                    </div>

                                    </div>
                                    

                                    <p className="mt-40">
  <b>2. Complete the Form</b>
  <ul className="list-disc pl-5 mt-2 space-y-2">
    <li>
      <b>Name:</b> Provide a clear, descriptive label for your mailbox.
    </li>
    <li>
      <b>Duplicate Filename Policy:</b> Defines how the system handles attachments with existing filenames:
      <ul className="list-disc pl-5 mt-1">
        <li>
          <b>Rename file:</b> A unique identifier is added to the beginning of the filename (e.g., <code>1695a9d664ee19894850a_report.docx</code> instead of <code>report.docx</code>).
        </li>
        <li>
          <b>Overwrite file:</b> The existing file in the destination will be replaced with the new one.
        </li>
      </ul>
    </li>
    <li>
      <b>Source:</b> Choose the datasource where incoming email attachments should be transferred.
    </li>
    <li>
      <b>Directory (Optional):</b> Specify a target directory within the selected datasource.
    </li>
  </ul>
</p>


                                    
                                    <div className='col-lg-8 col-12 order-lg-0'>
                                          
                              
                                            <img
                                                src='/assets/blog/mailboxes/mailboxes_3.png'
                                                className='img-fluid'
                                                alt='feature-img'
                                            />
                                    </div>


                                     <p className="mt-40">
                                        <b>3. Try it out</b>

                                        Once your mailbox is set up, send a test email to the generated address with one or more attachments.
                                        You can view a full audit trail of all received emails and attachments directly from the mailbox overview.
                                    
                                    </p> 

                                    
                                    <div className='col-lg-8 col-12 order-lg-0'>
                                          
                              
                                            <img
                                                src='/assets/blog/mailboxes/mailboxes_4.png'
                                                className='img-fluid'
                                                alt='feature-img'
                                            />
                                    </div>
                                    

        

                     

    

                                

                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <TrialBanner />

                <FooterOne footerLight />
            </Layout>
        </>
    );
};

export default BlogDetails;
